module.exports = __webpack_public_path__ + "img/dark.1f1de337.png";